/* La Bascule : écrit en clair les couleurs de chaque article (panier, paiement, commande) */
(function () {
  'use strict';
  function patch() {
    var B = window.Bascule;
    if (!B || typeof B.addToCart !== 'function' || B.addToCart._couleurs) return;
    var orig = B.addToCart;
    var index = null;
    function build() {
      index = {};
      var d = (B.cfg && B.cfg.data) || {};
      Object.keys(d.inter || {}).forEach(function (f) {
        var p = d.inter[f];
        if (!p || !p.v) return;
        Object.keys(p.v).forEach(function (k) {
          var c = k.split('|');
          index[p.v[k]] = { cache: c[0], bascule: c[1] };
        });
      });
      Object.keys(d.prise || {}).forEach(function (f) {
        var p = d.prise[f];
        if (!p || !p.v) return;
        Object.keys(p.v).forEach(function (k) { index[p.v[k]] = { cache: k }; });
      });
      if (d.embout && d.embout.v) {
        Object.keys(d.embout.v).forEach(function (k) { index[d.embout.v[k]] = { embout: k }; });
      }
    }
    function enrich(it) {
      var info = index[it.id];
      var old = it.properties || {};
      if (!info) return it;
      var p = {};
      if (info.cache) {
        p['Couleur du cache'] = info.cache;
        if (info.bascule) p['Couleur de la bascule'] = info.bascule;
        Object.keys(old).forEach(function (k) {
          if (k === 'Embout' && info.bascule) p['Embout'] = old[k] + ' (couleur ' + info.bascule + ')';
          else p[k] = old[k];
        });
        if (info.bascule && !old['Embout']) p['Embout'] = 'Classique (inclus)';
      } else if (info.embout) {
        p['Forme'] = info.embout;
        Object.keys(old).forEach(function (k) {
          p[k === 'Couleur' ? "Couleur de l'embout" : k] = old[k];
        });
      }
      var out = {};
      Object.keys(it).forEach(function (k) { out[k] = it[k]; });
      out.properties = p;
      return out;
    }
    var wrapped = function (items) {
      if (!index) build();
      return orig.call(this, (items || []).map(enrich));
    };
    wrapped._couleurs = true;
    B.addToCart = wrapped;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', patch);
  else patch();
})();
